// actionTypes
export const UPDATE_TITLE = "UPDATE_TITLE";
export const UPDATE_IMAGE = "UPDATE_IMAGE";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const UPDATE_SLUG = "UPDATE_SLUG";
export const UPDATE_CONTENT = "UPDATE_CONTENT";
export const UPDATE_BLOG_IMAGE = "UPDATE_BLOG_IMAGE";

//action creators
export const updateTitle = (title) => ({
  type: UPDATE_TITLE,
  payload: title,
});
export const updateImage = (image) => ({
  type: UPDATE_IMAGE,
  payload: image,
});

export const updateCategory = (category) => ({
  type: UPDATE_CATEGORY,
  payload: category,
});

export const updateSlug = (slug) => ({
  type: UPDATE_SLUG,
  payload: slug,
});

export const updateContent = (content) => ({
  type: UPDATE_CONTENT,
  payload: content,
});

export const updateBlogImage = (content) => ({
  type: UPDATE_BLOG_IMAGE,
  payload: content,
});
 
